import { useTranslation } from "react-i18next";
import styled from "styled-components";
import arrow_right from "assets/icons/arrow_right.svg";
import Chat from "./Chat";
import { useState } from "react";
import ChatPreview from "./ChatPreview";
import { useAppSelector } from "store/hooks";
import IProject from "common/interfaces/IProject";

interface CommsProps {
  isChatOpen: boolean;
  setIsChatOpen: any;
  styles?: any;
}

const Wrapper = styled.div`
  display: flex;
  height: 95%;
  background-color: #fcfaff;
  border: 2px solid #7d02fa;
  border-radius: 20px;
  align-self: center;
`;

const SmallIconBasic = styled.img`
  width: 7px;
  height: 14px;
`;

const SmallIcon = styled(SmallIconBasic)(
  ({ isChatOpen }: { isChatOpen: boolean }) => ({
    marginLeft: isChatOpen ? "auto" : "8px",
    marginRight: isChatOpen ? "10px" : "0",
  })
);

const ToggleButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  outline: none;
  font-weight: 700;
  padding: 22px 0 22px 28px;
  cursor: pointer;
`;

const ChatPreviewsWrapperBasic = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 300px;
`;

const ChatPreviewsWrapper = styled(ChatPreviewsWrapperBasic)(
  ({ expand }: { expand: boolean }) => ({
    width: expand ? "25%" : "100%",
    alignItems: expand ? "flex-first" : "center",
    borderRight: expand ? "1px solid #B3B3B3" : "none",
  })
);

export const chats = [
  {
    id: "111",
    firstName: "Christoph",
    lastName: "Amann",
    projectName: "WeCollab",
    createdAt: "07.12.2021",
  },
  {
    id: "222",
    firstName: "Maya",
    lastName: "Rahma",
    projectName: "Yumatch",
    createdAt: "30.11.2021",
  },
];

const Comms = ({ isChatOpen, setIsChatOpen, styles }: CommsProps) => {
  const { t } = useTranslation("common");
  const [chatId, setChatId] = useState<string>("");
  const [chatTitle, setChatTitle] = useState<string>("");
  const createdProjects = useAppSelector(
    (state) => state.projects.createdProjects
  );
  const joinedProjects = useAppSelector(
    (state) => state.projects.joinedProjects
  );

  return (
    <Wrapper style={styles}>
      <ChatPreviewsWrapper expand={isChatOpen}>
        {isChatOpen ? (
          <ToggleButton onClick={() => setIsChatOpen(false)}>
            {t("chat")}
            <SmallIcon
              isChatOpen={isChatOpen}
              src={arrow_right}
              style={{ transform: "scaleX(-1)" }}
            />
          </ToggleButton>
        ) : (
          <ToggleButton onClick={() => {}}>
            {t("chat")}
            <SmallIcon isChatOpen={isChatOpen} src={arrow_right} />
          </ToggleButton>
        )}
        {joinedProjects &&
          createdProjects &&
          [...joinedProjects, ...createdProjects].map((project: IProject) => (
            <ChatPreview
              key={project?._id}
              data={project}
              isOpen={chatId === project?._id}
              isChatOpen={isChatOpen}
              onClick={() => {
                setChatId(project?._id);
                setChatTitle(project?.title);
                setIsChatOpen(true);
              }}
            />
          ))}
      </ChatPreviewsWrapper>
      {isChatOpen ? <Chat chatId={chatId} title={chatTitle} /> : null}
    </Wrapper>
  );
};

export default Comms;
